/**
 * Card Web Component
 * ------------------
 * This component defines a custom HTML element <card-component>
 * that serves as a reusable container for content, styled to act
 * as a slide within a carousel or standalone card block.
 *
 * Features:
 * - Uses Shadow DOM for encapsulated styling.
 * - Provides a default slot for flexible child content.
 * - Includes minimal styling for scroll-snap carousel alignment.
 *
 * Example Usage:
 *  <card-component>
 *    <img src="image.jpg" alt="Sample" />
 *    <p>This is a card content area.</p>
 *  </card-component>
 *
 *  <carousel-component>
 *    <card-component>...</card-component>
 *    <card-component>...</card-component>
 *  </carousel-component>
 */

const Card = (function () {
  // --- Define component template (structure + scoped styles) ---
  let comptemplate = document.createElement("template");
  comptemplate.innerHTML = `            
    <style>
      /* Each card aligns neatly within a scrollable carousel */
      .carousel-slide {
        scroll-snap-align: center;
        overflow: hidden;
        width: 100%
      }
    </style>

    <!-- Card container; slot allows flexible child content -->
    <div id="card-container" class="carousel-slide">
      <slot></slot>
    </div>
  `;

  /**
   * Card custom element definition.
   */
  class Card extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Lifecycle: called when the element is inserted into the DOM.
     * Attaches the Shadow DOM and injects the template for style isolation.
     */
    connectedCallback() {
      const template = comptemplate;
      this.root = this.attachShadow({ mode: "open" });
      this.root.appendChild(template.content.cloneNode(true));
    }
  }

  // --- Register the custom element ---
  customElements.define("card-component", Card);

  return Card;
})();

export { Card };
